import { EMOJI_SHORTCODES } from './shortcodes.js';
/** Text emoticon → unicode (longest match first when converting). */
export const EMOTICON_MAP = [
    [":'(", '😢'],
    [':-(', '☹️'],
    [':-)', '😀'],
    [':-D', '😄'],
    [':-P', '😛'],
    [':-p', '😛'],
    [':-o', '😮'],
    [':-O', '😮'],
    [':-/', '😕'],
    [':-\\', '😕'],
    [':-*', '😘'],
    [':-X', '🤐'],
    [':-x', '🤐'],
    [':-3', '😊'],
    [';-(', '😢'],
    [';-)', '😉'],
    [':)', '😀'],
    [':D', '😄'],
    [':P', '😛'],
    [':p', '😛'],
    [':o', '😮'],
    [':O', '😮'],
    [':(', '☹️'],
    [';)', '😉'],
    ['<3', '❤️'],
    [':x', '🤐'],
    [':X', '🤐'],
    [':/', '😕'],
    [':\\', '😕'],
    [':*', '😘'],
    [':3', '😊'],
];
const SORTED = [...EMOTICON_MAP].sort((a, b) => b[0].length - a[0].length);
/** Replace trailing emoticons at end of text (e.g. after space). */
export function convertTrailingEmoticons(text) {
    let result = text;
    let changed = true;
    while (changed) {
        changed = false;
        for (const [key, emoji] of SORTED) {
            if (result.endsWith(key)) {
                result = result.slice(0, -key.length) + emoji;
                changed = true;
                break;
            }
        }
    }
    return result;
}
/** Replace :shortcode: patterns with unicode emojis. */
export function applyEmojiShortcodes(text, extraShortcodes) {
    return text.replace(/:([a-zA-Z0-9_+-]+):/g, (match, name) => {
        const key = name.toLowerCase();
        return extraShortcodes?.[key] ?? EMOJI_SHORTCODES[key] ?? EMOJI_SHORTCODES[name] ?? match;
    });
}
export function formatMessageContent(text, opts = {}) {
    let out = applyEmojiShortcodes(text, opts.customShortcodes);
    if (opts.convertEmoticons)
        out = convertTrailingEmoticons(out);
    return out;
}
//# sourceMappingURL=emoticons.js.map